export const url = {
  category: '/auth/public/get_goodsMarketCategory',
  claimList: '/auth/claim/searchByFirstLetter',
  province: '/auth/public/get_province',
  // product
  top10Goods: '/auth/rank/top10Goods',
  goodRelatedFormulations: '/auth/rank/relatedFormaulations',
  goodRelatedConcepts: '/auth/rank/relatedConcepts',
  // claim
  top10Claim: '/auth/rank/top10Claim',
  claimRelatedFormulations: '/auth/rank/claimRelatedFormaulations',
  claimRelatedConcepts: '/auth/rank/claimRelatedConcepts',
  claimMatchClaim: '/auth/rank/claimMatchClaim',
  // brand
  top10Brand: '/auth/rank/top10Brand',
  // brand
  top10Group: '/auth/rank/top10Group',
  getNewDataDate: '/auth/rank/getNewDataDate',
  getTop10Ingredient: '/auth/rank/top10Ingredient'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/topRanking.js